module.exports = __webpack_public_path__ + "static/media/customStep3.928b5a3c.png";